var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMexico(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 16C31.9993 9.65665 28.3077 4.17565 22.9558 1.58765V30.4123C28.3077 27.8244 31.9993 22.3434 31.9993 16V16Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 22.3434 3.69156 27.8244 9.0435 30.4124V1.58765C3.69156 4.17565 0 9.65665 0 16Z",
    fill: "#6DA544"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8262 16C11.8262 18.3052 13.6949 20.1739 16.0001 20.1739C18.3053 20.1739 20.1741 18.3052 20.1741 16V14.6087H11.8262V16Z",
    fill: "#6DA544"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5651 13.2174H17.3911C17.3911 12.449 16.7682 11.826 15.9998 11.826C15.2314 11.826 14.6085 12.449 14.6085 13.2174H10.4346C10.4346 13.9858 11.1039 14.6087 11.8722 14.6087H11.8259C11.8259 15.3771 12.4488 16 13.2172 16C13.2172 16.7684 13.8401 17.3913 14.6085 17.3913H17.3911C18.1596 17.3913 18.7824 16.7684 18.7824 16C19.5509 16 20.1737 15.3771 20.1737 14.6087H20.1274C20.8958 14.6087 21.5651 13.9858 21.5651 13.2174Z",
    fill: "#FF9811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexico);
export default __webpack_public_path__ + "static/media/mexico.25110693.svg";
export { ForwardRef as ReactComponent };